import { Helmet, HelmetProvider } from 'react-helmet-async';
import ProfileDashboardIcon from "../../assets/profile_dashboard.png";
import SpacesDashboardIcon from "../../assets/spaces_dasboard.png";

import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import useUserCategoriesHook from '../../api/userCategories';
import {useTranslation} from "react-i18next";

const Home = () => {
    const { auth } = useAuth();
    const {t} = useTranslation();

    // Use the user categories hook to fetch categories
    const { getGuestCategories, getAdminCategories } = useUserCategoriesHook({});

    // Fetch appropriate categories based on auth state
    const { data: categoriesData, isLoading } = auth?.userInfo ? getAdminCategories : getGuestCategories;

    if (isLoading) {
        return <div>Loading...</div>;
    }

    // Extract available categories from the fetched data
    const categories = categoriesData?.categories || [];

    // Helper function to check if a path exists in the user's categories
    const hasCategoryPath = (path) => categories.some(category => category.path === path);

    return (
        <>
            <HelmetProvider>
                <Helmet>
                    <title>Communitism Project</title>
                    <meta property='og:title' content='Home Page' key='title' />
                </Helmet>
            </HelmetProvider>

            <div className='d-flex justify-content-center align-items-center' style={{ height: '30vh' }}>
                <span className='text-muted'>
                    <h3 className='home-animation-h3'>
                        <span className='home-animation-span'>Communitism</span>
                        <span className='home-animation-span'>Project</span>
                    </h3>
                </span>
            </div>

            {/* Icon Section */}
            <div className='container mt-4'>
                <div className='row justify-content-center'>

                    {/* Conditionally render the Orders Icon with Title if the user has access to /admin/orders */}
                    {hasCategoryPath('/admin/spaces') && (
                        <div className="col-12 col-sm-6 col-md-4">
                            <div className="text-center dashboard-main-icon-block mb-4">
                                <Link to='/admin/spaces' className='dashboard-main-icon'>
                                    <img
                                        src={SpacesDashboardIcon}
                                        alt='Spaces Dashboard Icon'
                                        className='img-fluid'
                                    />
                                </Link>
                                <p className='dashboard-main-icon-title'>{t('Spaces')}</p>
                            </div>
                        </div>
                    )}

                    {/* Conditionally render the UserProfile Icon with Title if the user has access to /admin/account/profile */}
                    {hasCategoryPath('/admin/account/profile') && (
                        <div className="col-12 col-sm-6 col-md-4">
                            <div className="text-center dashboard-main-icon-block mb-4">
                                <Link to='/admin/account/profile' className='dashboard-main-icon'>
                                    <img
                                        src={ProfileDashboardIcon}
                                        alt='UserProfile Dashboard Icon'
                                        className='img-fluid'
                                    />
                                </Link>
                                <p className='dashboard-main-icon-title'>{t('User Profile')}</p>
                            </div>
                        </div>
                    )}

                </div>
            </div>
        </>
    );
}

export default Home;
